import React from "react";
import { cls } from "shared/lib/util/classnames";

interface Props {
  onClick: () => void;
  isRemove?: boolean;
}

export function AddBtn({ onClick, isRemove }: Props) {
  return (
    <button
      className={cls(
        isRemove
          ? "border-gray-5 bg-white text-gray-5"
          : "border-blue-1 bg-blue-1 text-white",
        "flex h-[40px] w-[104px] items-center justify-center gap-[6px] rounded-[8px] border-[1px] text-[14px] font-semibold",
      )}
      onClick={onClick}
    >
      {isRemove ? "삭제하기" : "추가하기"}
    </button>
  );
}
